import { render, staticRenderFns } from "./CardBoxesContainer.vue?vue&type=template&id=70564e94&scoped=true"
import script from "./CardBoxesContainer.vue?vue&type=script&lang=js"
export * from "./CardBoxesContainer.vue?vue&type=script&lang=js"
import style0 from "./CardBoxesContainer.vue?vue&type=style&index=0&id=70564e94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70564e94",
  null
  
)

export default component.exports